import React, { useState, useEffect } from 'react';
import { Eye } from 'lucide-react';

export const VisitCounter = () => {
  const [visits, setVisits] = useState(null);

  useEffect(() => {
    // Effect must run exactly once on mount to avoid double-counting visits.
    // All referenced values (API URL, sessionStorage, setVisits) are module-level
    // or React-stable, so there are no stale-closure risks.
    const apiUrl = process.env.REACT_APP_BACKEND_URL;
    const hasVisited = sessionStorage.getItem('hasVisited');

    const fetchCount = () =>
      fetch(`${apiUrl}/api/visits`)
        .then((res) => res.json())
        .then((data) => setVisits(data.count))
        .catch(() => setVisits(0));

    if (hasVisited) {
      fetchCount();
      return;
    }

    fetch(`${apiUrl}/api/visits`, { method: 'POST' })
      .then((res) => res.json())
      .then((data) => {
        setVisits(data.count);
        sessionStorage.setItem('hasVisited', 'true');
      })
      .catch(fetchCount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (visits === null) return null;

  return (
    <div className="flex items-center gap-2 text-text-secondary" data-testid="visit-counter">
      <Eye className="w-4 h-4" />
      <span className="text-sm">
        {visits.toLocaleString('it-IT')} {visits === 1 ? 'visita' : 'visite'}
      </span>
    </div>
  );
};
